<div class="error-box">

    <div *ngIf="errorMessage == 'errorMessage-noFlightToday' || errorMessage == 'errorMessage-noFlight'">
        <h2>{{'errorMessage-oops' | locale}}</h2>
        <div style="margin-top: 1em;"> {{errorMessage| locale }}</div>
    </div>
    <div *ngIf="errorMessage == 'errorMessage-serverDown'">
        <h2>{{'errorMessage-error' | locale}}</h2>
        <div style="margin-top: 1em;"> {{errorMessage| locale }}</div>
    </div>